// src/Carousel.js
import React, { useState, useEffect } from "react";
import heroimage1 from "../assets/img/bg1.jpg";
import heroimage2 from "../assets/img/bg2.jpg";
import heroimage3 from "../assets/img/bg3.jpg";

export const HomeCarousel = () => {
  const banners = [
    {
      id: 1,
      image: heroimage1,
      title: "Delivering across the Globe",
    },
    {
      id: 2,
      image: heroimage2,
      title: "Sourcing Speciality Products Across, Especially for You.",
    },
    {
      id: 3,
      image: heroimage3,
      title: "Quality Check",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Automatically transition to the next banner every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 3000);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? banners.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  return (
    <div className="carousel">
      <div className="carousel-inner">
        {banners.map((banner, index) => (
          <div
            key={banner.id}
            className={`carousel-item ${
              index === currentIndex ? "active" : ""
            }`}
          >
            <img src={banner.image} alt={banner.title} />
            <div className="carousel-content">
              <h2>{banner.title}</h2>
             
            </div>
          </div>
        ))}
      </div>
      {/* Navigation buttons */}
      <button className="prev" onClick={goToPrevious}>
        &#10094;
      </button>
      <button className="next" onClick={goToNext}>
        &#10095;
      </button>
    </div>
  );
};
